import { useContext, useEffect } from "react";

import { AuthContext } from "../../context/Auth/AuthContext";
import { ColorModeContext } from "../../context/Theme/ColorModeContext";

// Ponte entre a preferência salva no banco (user) e o tema aplicado.
// Quando o usuário carrega (login / reload / update via socket "user"),
// reflete user.darkMode e user.fontSizeMensagens no ColorModeContext.
// Componente headless (sem UI).
const ThemeUserSync = () => {
	const { user } = useContext(AuthContext);
	const { setDarkMode, setFontSize } = useContext(ColorModeContext);

	useEffect(() => {
		if (!user || !user.id) return;
		if (typeof user.darkMode === "boolean") {
			setDarkMode(user.darkMode);
		}
		if (user.fontSizeMensagens) {
			setFontSize(user.fontSizeMensagens);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [user?.id, user?.darkMode, user?.fontSizeMensagens]);

	return null;
};

export default ThemeUserSync;
